module.exports = __webpack_public_path__ + "img/coronavirus-logo-concept.444d9ebc.png";